module.exports = __webpack_public_path__ + "static/img/jigou-4-bottom.fb413f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-4-bottom.png
// module id = NR7t
// module chunks = 2